import {
  Button,
  CloseIcon,
  Drawer,
  InputDebounce,
  Radio,
  Select,
  Text,
} from '@mercai/clever'
import { useTranslation } from 'react-i18next'

import styles from './drawer-filter.module.css'

import { useVehiclesList } from '@/services'
import { DrawerFilterProps } from './drawer-filter.type'

export const TransportCompanyRoutesDrawerFilter = ({
  isOpen,
  onHandleOpen,
  filter,
  onHandleFilter,
}: DrawerFilterProps) => {
  const { t } = useTranslation('screenLogistic')

  const { data: vehiclesData } = useVehiclesList({})

  return (
    <Drawer isOpen={isOpen} onHandleOpen={onHandleOpen}>
      <div className={styles.header}>
        <Text variant="title-large" className={styles['header-title']}>
          {t('transportCompaniesRoutesFilterTitle')}
        </Text>

        <button
          className={styles['header-button']}
          type="button"
          onClick={onHandleOpen}
        >
          <CloseIcon />
        </button>
      </div>

      <div className={styles.content}>
        <div className={styles['content-filter']}>
          <Text variant="title-base">
            {t('transportCompaniesRoutesFilterOriginLabel')}
          </Text>

          <InputDebounce
            value={filter.logisticRoute_OriginLocation}
            onChange={(value) =>
              onHandleFilter({
                ...filter,
                logisticRoute_OriginLocation: value,
              })
            }
            placeholder={t('searchFilterPlaceholder')}
          />
        </div>
        <div className={styles['content-filter']}>
          <Text variant="title-base">
            {t('transportCompaniesRoutesFilterDestinationLabel')}
          </Text>

          <InputDebounce
            value={filter.logisticRoute_DestinationLocation}
            onChange={(value) =>
              onHandleFilter({
                ...filter,
                logisticRoute_DestinationLocation: value,
              })
            }
            placeholder={t('searchFilterPlaceholder')}
          />
        </div>

        <div className={styles['content-filter']}>
          <Text variant="title-base">
            {t('transportCompaniesRoutesFilterVehicleLabel')}
          </Text>

          <Select
            value={filter.vehicle_Name}
            onChange={(value) =>
              onHandleFilter({ ...filter, vehicle_Name: value })
            }
            options={
              vehiclesData?.data?.results?.map((vehicle) => ({
                label: vehicle.name,
                value: vehicle.name,
              })) || []
            }
            placeholder={t('transportCompaniesRoutesFilterVehiclePlaceholder')}
          />
        </div>

        <div className={styles['content-filter']}>
          <Text variant="title-base">
            {t('transportCompaniesRoutesFilterIsActive')}
          </Text>

          <div className={styles['radio-group']}>
            <Radio
              value={filter.isActive === ''}
              onChange={() => onHandleFilter({ ...filter, isActive: '' })}
            >
              {t('transportCompaniesRoutesFilterIsActiveAll')}
            </Radio>

            <Radio
              value={filter.isActive === 'true'}
              onChange={() => onHandleFilter({ ...filter, isActive: `true` })}
            >
              {t('transportCompaniesRoutesFilterIsActiveYes')}
            </Radio>

            <Radio
              value={filter.isActive === 'false'}
              onChange={() => onHandleFilter({ ...filter, isActive: `false` })}
            >
              {t('transportCompaniesRoutesFilterIsActiveNo')}
            </Radio>
          </div>
        </div>
      </div>

      <div className={styles.footer}>
        <Button variant="secondary" onClick={onHandleOpen}>
          {t('transportCompaniesRoutesButtonBack')}
        </Button>
      </div>
    </Drawer>
  )
}
